// /App.js
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import PasswordReset from "./pages/PasswordReset";
import Interview from "./pages/Interview";
import ArticlePage from "./pages/ArticlePage";
import ProjectPage from "./pages/ProjectPage";
import CompanyPage from "./pages/CompanyPage";
import React from "react";

const App = () => (
  <Router
    future={{
      v7_relativeSplatPath: true, // Opt-in to future React Router behavior
      v7_startTransition: true, // Opt-in to React.startTransition wrapping
    }}
  >
    <main>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/article/:slug" element={<ArticlePage />} />
        <Route path="/company/:companySlug" element={<CompanyPage />} />
        <Route path="/company/:companySlug/project/:projectSlug" element={<ProjectPage />} />
        <Route path="/password-reset" element={<PasswordReset />} />
        <Route path="/interview" element={<Interview />} />
      </Routes>
    </main>
  </Router>
);

export default App;